import { render, staticRenderFns } from "./CChartPolarAreaExample.vue?vue&type=template&id=c5728712&"
import script from "./CChartPolarAreaExample.vue?vue&type=script&lang=js&"
export * from "./CChartPolarAreaExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports